import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import ForumOutlined from '@mui/icons-material/ForumOutlined';
import LocalPhone from '@mui/icons-material/LocalPhone';
import type { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export interface Item {
    id: string;
    title: string;
    type: string;
    url: string;
    icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string;
    };
    external?: boolean;
    target?: boolean;
    disabled?: boolean;
    breadcrumbs?: boolean;
}

export const MENU_OPTIONS: Item[] = [
    {
        id: 'campaigns',
        title: 'campaigns',
        type: 'item',
        url: '/campaigns',
        icon: LocalPhone,
        breadcrumbs: false,
    },
    {
        id: 'bots',
        title: 'my_bots',
        type: 'item',
        url: '/bots',
        icon: ForumOutlined,
        external: true,
        target: true,
    },
    {
        id: 'analytics',
        title: 'analytics',
        type: 'item',
        url: '/analytics',
        icon: AssessmentOutlined,
        external: true,
        target: true,
    },
    {
        id: 'call',
        title: 'voicebot_call',
        type: 'item',
        url: '/voicebot',
        icon: ForumOutlined,
        external: true,
        target: true,
    },
    // finalize and add rw role
    {
        id: 'stats',
        title: 'Dashboard',
        type: 'item',
        url: '/statistics',
        icon: AssessmentOutlined,
        external: true,
        target: true,
    },
    {
        id: 'stats',
        title: 'Dashboard',
        type: 'item',
        url: '/statistics/penam-dashboard',
        icon: AssessmentOutlined,
        external: true,
        target: true,
    },
];
